import React, { useEffect, useState } from "react";
import { useDevice } from "../../../Utils";
import PackageToogleButton from "../helperComponent/PackageToggleButton";
import PaidRoomTable from "./PaidRoomTable";
import SubscriptionTable from "./SubscriptionTable";
import { ct } from "../../../../constant-Utils";
import { FEATURE_CUSTOM_REDUX } from "../../../../constant";
import { useSelector } from "react-redux";
import i18next from "i18next";

const PaymentHistoryMain = () => {
  const { isMobile, isTablet } = useDevice();
  const [renderKey, setRenderKey] = useState(1);
  const { showLoader } = useSelector((state) => state[FEATURE_CUSTOM_REDUX]);

  useEffect(() => {
    setRenderKey(oldState => oldState + 1);
  }, [i18next.language])

  console.log({ isMobile, isTablet });
  const [type, setType] = useState("subscription");
  const handleOnChange = activeTab => {
    console.log({ activeTab });
    setType(activeTab);
  };

  return (
    <div key={`renderKey${renderKey}`} id="payment-history-wrapper" className="payment-table-custom-cont">
      <div className="w-100 text-center pb-4">
        <PackageToogleButton
          handleChange={handleOnChange}
          type={type}
          types={{ type1: "subscription", type2: "paidRoom" }}
          buttonName1={ct("rta-trmc.dashboard.paymentHistory.typography.subscription")}
          buttonName2={ct("rta-trmc.dashboard.paymentHistory.typography.paidRoom")}
          style={{ wrapperBoxWidth: "225px", boxWidth: "110px" }}
          className={"mask-subs"}
        />
      </div>
      {type === "subscription" ? <SubscriptionTable /> : <PaidRoomTable />}
    </div>
  );
};

export default PaymentHistoryMain;
